import { render, staticRenderFns } from "./PrestadoresIndisponiveisAoIntercambioDownload.vue?vue&type=template&id=74e708c8&scoped=true"
import script from "./PrestadoresIndisponiveisAoIntercambioDownload.vue?vue&type=script&lang=js"
export * from "./PrestadoresIndisponiveisAoIntercambioDownload.vue?vue&type=script&lang=js"
import style0 from "./PrestadoresIndisponiveisAoIntercambioDownload.vue?vue&type=style&index=0&id=74e708c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e708c8",
  null
  
)

export default component.exports